var exports = {
  "k": "x127c5a35--09cd00--container",
  "_": "x127c5a35--09cd00--close-button",
};

module.exports = exports;
